import "./styles.scss";

/**
 * Flag em SVG. Por enquanto suporta apenas en-US.
 * Pode evoluir para um mapa de bandeiras por `locale`.
 */
const FLAGS = {
  "en-US": (
    <svg viewBox="0 0 22 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="22" height="14" fill="#1D3557" />
      {[1, 3, 5, 7, 9, 11, 13].map((y) => (
        <rect key={`w-${y}`} y={y} width="22" height="1" fill="#FFFFFF" />
      ))}
      {[0, 2, 4, 6, 8, 10, 12].map((y) => (
        <rect key={`r-${y}`} y={y} width="22" height="1" fill="#E63946" />
      ))}
      <rect width="10" height="8" fill="#457B9D" />
    </svg>
  ),
};

const LanguageFlag = ({ locale = "en-US", className = "" }) => {
  const flag = FLAGS[locale];
  if (!flag) return null;
  return <span className={`languageFlag ${className}`.trim()}>{flag}</span>;
};

export default LanguageFlag;
